import { render, staticRenderFns } from "./InsightFilters.vue?vue&type=template&id=0d4faee3&"
import script from "./InsightFilters.vue?vue&type=script&lang=ts&"
export * from "./InsightFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports